module.exports = __webpack_public_path__ + "img/cloth_g3_sleeve-01.85e71019.svg";